import React from "react";
import "../styles/home.css";
import BottomNav from "../components/BottomNav";
import Navbar from "../components/Navbar";

const About = () => {
  return (
    <div className="about-container">
        <Navbar />
      <div className="about-hero">
        <h1>About M&L</h1>
        <p>Style. Confidence. Identity.</p>
      </div>

      <div className="about-content">
        <div className="about-section">
          <h2>Our Story</h2>
          <p>
            M&L was created with a vision to bring best Shades and
            timeless style together. We believe glass is not just
            something you wear — it’s a statement of who you are.
          </p>
        </div>

        <div className="about-section">
          <h2>Our Mission</h2>
          <p>
            Our mission is to provide high-quality, affordable Shades
            that empowers people to express themselves confidently through 
            drop shipping.Our dealers are carefully selected to ensure that
             we offer only the best products to our customers.
             We are committed to delivering exceptional customer 
             service and building lasting relationships with our customers.
          </p>
        </div>

        <div className="about-section">
          <h2>Why Choose Us?</h2>
          <ul>
            <li>✔ Premium Quality Products</li>
            <li>✔ Affordable Pricing</li>
            <li>✔ Fast & Reliable Delivery</li>
            <li>✔ Customer Satisfaction First</li>
          </ul>
        </div>
      </div>
      <BottomNav />
    </div>
  );
};


export default About;